module.exports = __webpack_public_path__ + "img/policy.0f1077ef.png";